import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '@constants/queryKey';
import { fetchDocument } from '@repository/documentRepository';
import { minutesToMillis } from '@utils/millis';
import { FetchDocumentError, FetchDocumentResponse } from '@models/document/FetchDocument';

const useFetchDocument = (documentId?: number, editMode?: boolean) => {
    const isEditMode = editMode || false;
    return useQuery<FetchDocumentResponse, FetchDocumentError>({
        queryKey: [QueryKey.Document, documentId, isEditMode],
        queryFn: ({ signal }) => {
            if (!documentId) {
                return Promise.reject();
            }
            return fetchDocument(documentId, isEditMode, { signal });
        },
        staleTime: minutesToMillis(5),
        enabled: !!documentId,
    });
};

export default useFetchDocument;
